import React from "react";
import "./Volumes.css";

export default function Volumes() {
  const volumesData = [
    { volume: "Volume 1", issue: "Issue 2", year: "2023" },
    { volume: "Volume 2", issue: "Issue 1", year: "2024" },
    { volume: "Volume 3", issue: "Issue 2", year: "2025" },
  ];

  return (
    <section className="ijacna-volumes-section">
      <div className="ijacna-volumes-container">
        <h2 className="ijacna-volumes-heading">Journal Volumes</h2>
        <p className="ijacna-volumes-subtext">
          Explore all published volumes and issues of the International Journal
          of Advanced Computing and Network Applications.
        </p>

        <div className="ijacna-volumes-table-wrapper">
          <table className="ijacna-volumes-table">
            <thead>
              <tr>
                <th>Volume</th>
                <th>Issue</th>
                <th>Year</th>
              </tr>
            </thead>
            <tbody>
              {volumesData.map((item, index) => (
                <tr key={index}>
                  <td>{item.volume}</td>
                  <td>{item.issue}</td>
                  <td>{item.year}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
